// extracted by mini-css-extract-plugin
export default {"BannerRow":"style_BannerRow__Q19Mf"};